module.exports = __webpack_public_path__ + "static/img/02.8ede8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20241216/02.png
// module id = piw3
// module chunks = 0